<template>
<div class="container">
    <div class="hk-platform">
        <div class=" hk-container-padding">
            <div class="row">
                <div class="col-md-12 col-sm-12 mx-auto">
                    <div class="position-relative">
                        <h2 class="hk-heading text-center mt-5">Unlock Growth with HotelKey- 360 Degree Hospitality Services. One Single Platform</h2>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12  mx-auto">
                    <div class="button-grid">
                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon1.svg" loading="lazy" alt="Property Management System | HotelKey">
                            <p>{{ $t('hkplatform.property_management_system') }}</p>
                        </div>
                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon5.svg" loading="lazy" alt="Housekeeping | HotelKey">
                            <p>{{ $t('hkplatform.housekeeping') }}</p>
                        </div>

                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon2.svg" loading="lazy" alt="Maintenance | HotelKey">
                            <p>{{ $t('hkplatform.maintenance') }}</p>
                        </div>
                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon4.svg" loading="lazy" alt="Channel Management | HotelKey">
                            <p>{{ $t('hkplatform.channel_management') }}</p>
                        </div>
                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon3.svg" loading="lazy" alt="Website & Booking Engine | HotelKey">
                            <p>{{ $t('hkplatform.website_booking_engine') }}</p>
                        </div>

                        <div class="individual-button">
                            <img src="@/assets/home/hk-platform/icon1.svg" loading="lazy" alt="Point of Sale | HotelKey">
                            <p>{{ $t('hkplatform.point_of_sale') }}</p>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 d-block mx-auto">
                    <div class="image-container text-center">
                        <img src="@/assets/home/grow-better-hk.webp" class="d-block w-100" alt="Hospitality Single Platform | HotelKey" loading="lazy">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-10 col-sm-12 mx-auto">
                    <div class="text-center">
                        <p class="hk-subbody">Offers a comprehensive solution for all hospitality needs, all within a single, unified platform. Our all-in-one services encompass every aspect of hotel operations, from front desk management and housekeeping to reservations and guest engagement.</p>
                    </div>
                    <div class="pt-1 text-center">
                        <router-link :to="'/contact-team'" class="nav-link p-0">
                          <router-link :to="'/contact-team'" class="nav-link p-0">
                            <button type="button" class="btn hk-btn-demo-main me-2" :to="'contact-team'">
                                {{ $t("hk_all_btn.demo_btn") }}
                                <img src="@/assets/common/arrow-circle-right.svg" alt="arrow-circle-right-svg" class="w-auto demo-svg" />
                            </button>
                        </router-link>
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "HkPlatform",
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.button-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    justify-content: center;
}

.individual-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 10px;
    width: 188px;
    transition: transform 0.3s ease;
    border-radius: 6px;
    border: 2px solid rgba(184, 188, 199, 0.40);

    background: rgba(240, 245, 248, 0.00);

}

.individual-button:hover {
    transform: scale(1.05);

}

.individual-button img {
    margin-bottom: 5px;
    width: 40px;
}

.individual-button p {
    color: #000000;
    text-align: center;
    font-size: 12px;
    font-family: Inter;
    margin: 0;
}

.image-container {
    position: relative;
}

.main-img {
    width: 65%;
    margin-top: 3rem;
    object-fit: cover;
}

@media (max-width: 575.98px) {
    .headline {
        font-size: 1.5rem;
        line-height: 2rem;
    }

    .sub-body {
        font-size: 14px;
        line-height: 22px;
        font-family: Inter;
    }

    .individual-button {
        width: 100px;
        height: 100px;
        padding: 10px;
    }

    .individual-button img {
        width: 30px;
    }

    .main-img {
        width: 90%;
        margin-top: 2rem;
    }
}
</style>
